import myApi from '@/util/api'

export function getUsers () {

  return myApi.getAll('ApplicationUser/GetApplicationUsers')
}
export function getDocuments () {
  console.log('called');
  return myApi.getAll('Documents/GetDocuments')
}
export function getPublicFolders (id) {
  return myApi.getByID(id, 'Documents/GetPublicFolders')
}
export function getSubPublicFolderId(id, userId) {

  return myApi.getByuserId(id, userId, 'Documents/GetSubPublicFolderId')
}
export function getPublicFolderTreeId(id, userId) {

  return myApi.getByuserId(id, userId, 'Documents/GetPublicFolderId')
}
export function getDocument (data) {

  return myApi.getItem(data, "Documents/GetData")
}

export function createDocuments (data) {

  return myApi.create(data, "Documents/InsertDocuments")
}

export function updateDocuments (data) {

  return myApi.update(data.documentID, data, "Documents/UpdateDocuments")
}
export function deleteDocuments (data) {

  return myApi.delete(data.documentID, 'Documents/DeleteDocuments')
}
export function uploadDocuments (data) {

  return myApi.uploadFile(data, "Documents/UploadDocuments")
}
export function documentUsers (data) {
  return myApi.getByID(data, "DocumentAccess/GetDocumentAccess")
}
export function createDocumentAccess (data) {
  return myApi.create(data, "DocumentAccess/InsertDocumentAccess")
}
export function updateDocumentAccess (data) {

  return myApi.update(data.documentAccessID, data, "DocumentAccess/UpdateDocumentAccess")
}
export function downloadFile (data) {

  return myApi.downDocument(data, "Download/DownLoadDocument")
}


// WEBPACK FOOTER //
// ./src/api/document.js